import React from 'react'
// import BgImage from "../images/acfan.jpg";
import { Link } from 'react-router-dom';
import BlogListpub from '../../Blog/BlogListpub';


function Blogs() {
  return (
    <div className='pt-5'>
    <div
      style={{
        backgroundImage: `url(https://swastikengineers.net/static/media/acfan.ffd0da379b93a2b40ba6.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        width: "100%",
        minHeight: "150px", // mobile friendly chhota height
        paddingTop: "50px",
        paddingBottom: "30px",
        position: "relative",
        color: "white",
      }}
      className="d-flex align-items-center"
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1,
        }}
        className="overlay"
      ></div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          margin: "0 auto",
          textAlign: "center",
          padding: "0 15px",
        }}
        className="p-3"
      >
        <h1
          className="fw-bold"
          style={{ fontSize: "clamp(2.1rem, 5vw, 2rem)", fontWeight: "900", color: "white" }}
        >
          Our Blogs
        </h1>
        <p
          className="lead"
          style={{
            fontSize: "clamp(1.3rem, 2.5vw, 1rem)",
            margin: "0.5rem 0 1rem 0",
            color: "whitesmoke",
          }}
        >
          Stay updated with the latest insights, knowledge, and teachings from PSF Explore articles and resources that guide you toward values, culture, and a meaningful life rooted in Sanatan Dharma.
        </p>

        {/* Breadcrumbs */}
        <nav aria-label="breadcrumb">
          <ol
            style={{
              listStyle: "none",
              display: "flex",
              justifyContent: "center",
              padding: 0,
              margin: 0,
            }}
          >
            <li style={{ marginRight: "5px" }}>
              <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                Home
              </Link>
              <span style={{ margin: "0 5px" }}>/</span>
            </li>
            <li style={{ color: "white" }}>Our Blogs</li>
          </ol>
        </nav>
      </div>
    </div>      
         
         
      <BlogListpub />
    </div>
  )
}

export default Blogs
